import React, { useEffect, useState } from "react";
import { GetCategories } from "../../API/endpoints/Common";
import { BrandsType } from "./dtos/brands.dtos";
import MultiSelectWithAddItem from "../components/BrandsPartnerComponents/MultiselectComponentWithAddItem";
import { useBrandsOnboarding } from "../../contexts/BrandsOnboardingContext";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";


const foodAndBeverages = [
  'Bars',
  'Snacking',
  'None',
  'Ready To Mix Beverages',
  'Replacement Meals',
  'RTD Beverages',
  // 'Other',
];
const healthSupplements = [
  "Vitamins & Minerals",
  "Herbal & Natural Supplements",
  "Immune Support & Wellness",
  "Sports & Fitness Supplements",
  "Weight Management",
  "Women’s Health",
  "Men’s Health",
  "Mental Health & Sleep Support",
  "Digestive Health",
  "Heart & Cardiovascular Health"
];
const beautyAndSkin = [
  "Skincare",
  "Hair Care",
  "Body Care",
  "Wellness & Inner Beauty",
  "Dermatology & Treatments"
];
const petNutrition = [
  "Dental",
  "Food",
  "Supplements",
  "Snacking",
  // "Other"
];
type Props = {
  data: BrandsType;
  setData: React.Dispatch<React.SetStateAction<BrandsType>>;
  previousStep: () => void;
  nextStep: () => void;
  isMobile?: boolean;
};
const AreaOfExpertisePage: React.FC<Props> = ({
  data,
  setData, nextStep, previousStep, isMobile = false
}) => {
  const [checkedHealthSuppliments, setCheckedHealthSuppliments] = useState(true);
  const [checkedBeauty, setCheckedBeauty] = useState(true);
  const [checkedFood, setCheckedFood] = useState(true);
  const [otherInputValueFAB, setOtherInputValueFAB] = useState("");
  const [checkedPetNutrition, setCheckedPetNutrition] = useState(true);
  const [checkedHealtSupplements, setCheckedHealtSupplements] = useState(false);
  const { customOptionsMap, setCustomOptionsMap } = useBrandsOnboarding();
  const [validationError, setValidationError] = useState("");
  const [categories, setCategories] = useState([]);
  const [validationErrorForall, setValidationErrorForall] = useState<{
    [key: string]: string;
  }>({});


  const handleNext = () => {
    // Initialize an empty array for error messages
    let errorMessage: { [key: string]: string } = {};
    let error='';
    const health = data.focus_categories?.find(fc => fc.category === "Health Supplements")?.sub_category || []
    const beauty = data.focus_categories?.find(fc => fc.category === "Beauty & Skin")?.sub_category || []
    const food = data.focus_categories?.find(fc => fc.category === "Functional Food & Beverages")?.sub_category || []
    const pet = data.focus_categories?.find(fc => fc.category === "Pet Nutrition")?.sub_category || []
    if (health.length === 0&&beauty.length === 0&&food.length === 0&&pet.length === 0) {
      error = "Please select at least one item in Focus Category. ";
    }
    let errors: { [key: string]: string } = {};

    const findSubCategory = (category: string) =>
      data.focus_categories?.find((fc) => fc.category === category)?.sub_category || [];
  
    // Validate Functional Food & Beverages
    if (
      data.focus_categories?.some((fc) => fc.category === "Functional Food & Beverages") &&
      findSubCategory("Functional Food & Beverages").length === 0
    ) {
      errors.functionalFoodAndBeverages = "Please select at least one item in Functional Food & Beverages.";
    }
  
    // Validate Health Supplements
    if (
      data.focus_categories?.some((fc) => fc.category === "Health Supplements") &&
      findSubCategory("Health Supplements").length === 0
    ) {
      errors.healthSupplements = "Please select at least one item in Health Supplements.";
    }
  
    // Validate Beauty & Skin
    if (
      data.focus_categories?.some((fc) => fc.category === "Beauty & Skin") &&
      findSubCategory("Beauty & Skin").length === 0
    ) {
      errors.beautyAndSkin = "Please select at least one item in Beauty & Skin.";
    }
  
    // Validate Pet Nutrition
    if (
      data.focus_categories?.some((fc) => fc.category === "Pet Nutrition") &&
      findSubCategory("Pet Nutrition").length === 0
    ) {
      errors.petNutrition = "Please select at least one item in Pet Nutrition.";
    }
  
    // Set errors and stop if any
    if (Object.keys(errors).length > 0) {
      setValidationErrorForall(errors);
      return;
    }
  
    setValidationError(error);
    if (error!== "") {
      // If there are error messages, set the validation error state and return
      return;
    }
    nextStep();
  }
  useEffect(() => {
    (async () => {
      try {
        const response = await GetCategories();
        setCategories(response.data);
      } catch (error) { }
    })();
  }, []);

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Your Area of Expertise </div>
      <div className="common-sub-text pb-[60px]">
        We would like to understand your current focus segments across
        categories. Select all that applies.
        {validationError !== ""&& (
            <div className="text-red-500 text-sm !my-0">{validationError}</div>
          )}
      </div>

      {/* Grid Container */}
      <div className="grid grid-cols-1   gap-y-[32px]">

        <MultiSelectWithAddItem
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          label="Health Supplements"
          activeMarket="brands"
          error={validationErrorForall.healthSupplements}

          isFromBrands={true}
          contextKey="healthSupplements"
          options={healthSupplements}
          showAddCustom
          selected={
            data.focus_categories?.find((fc) => fc.category === "Health Supplements")
              ?.sub_category || []
          }
          setSelected={(val) => {
            setData((prev) => {
              const updated = [...(prev.focus_categories || [])];
              const index = updated.findIndex(
                (fc) => fc.category === "Health Supplements"
              );

              if (index !== -1) {
                updated[index].sub_category = val;
              } else {
                updated.push({
                  category: "Health Supplements",
                  sub_category: val,
                });
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            });
          }}
          checked={
            !!data.focus_categories?.some(
              (fc) => fc.category === "Health Supplements"
            )
          }
          setChecked={() =>
            setData((prev) => {
              const current = [...(prev.focus_categories || [])];
              const exists = current.find(
                (fc) => fc.category === "Health Supplements"
              );

              let updated: typeof current;

              if (exists) {
                updated = current.filter(
                  (fc) => fc.category !== "Health Supplements"
                );
              } else {
                updated = [
                  ...current,
                  { category: "Health Supplements", sub_category: [] },
                ];
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            })
          }
          showCheckBox={true}
        />

        {/* Beauty & Skin */}
        <MultiSelectWithAddItem
          isFromBrands={true}
          label="Beauty & Skin"
          error={validationErrorForall.beautyAndSkin}
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          activeMarket="brands"
          contextKey="beautyAndSkin"
          options={beautyAndSkin}
          showAddCustom
          selected={
            data.focus_categories?.find((fc) => fc.category === "Beauty & Skin")
              ?.sub_category || []
          }
          setSelected={(val) => {
            setData((prev) => {
              const updated = [...(prev.focus_categories || [])];
              const index = updated.findIndex(
                (fc) => fc.category === "Beauty & Skin"
              );

              if (index !== -1) {
                updated[index].sub_category = val;
              } else {
                updated.push({
                  category: "Beauty & Skin",
                  sub_category: val,
                });
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            });
          }}
          checked={
            !!data.focus_categories?.some(
              (fc) => fc.category === "Beauty & Skin"
            )
          }
          setChecked={() =>
            setData((prev) => {
              const current = [...(prev.focus_categories || [])];
              const exists = current.find(
                (fc) => fc.category === "Beauty & Skin"
              );

              let updated: typeof current;

              if (exists) {
                updated = current.filter(
                  (fc) => fc.category !== "Beauty & Skin"
                );
              } else {
                updated = [
                  ...current,
                  { category: "Beauty & Skin", sub_category: [] },
                ];
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            })
          }
          showCheckBox={true}
        />

        {/* Functional Food & Beverages */}
        <MultiSelectWithAddItem
        error={validationErrorForall. functionalFoodAndBeverages}
        isFromBrands={true}
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          showAddCustom={true}
          activeMarket="brands"
          label="Functional Food & Beverages"
          contextKey="functionalFoodAndBeverages"
          options={foodAndBeverages}
          // selected={data.markets[activeMarket]?.focus_categories?.["Functional Food & Beverages"] || []}
          selected={data.focus_categories?.find(fc => fc.category === "Functional Food & Beverages")?.sub_category || []

          }
          setSelected={(val) => {
            setData((prev) => {
              const updated = [...(prev.focus_categories || [])];
              const index = updated.findIndex(fc => fc.category === "Functional Food & Beverages");

              if (index !== -1) {
                updated[index].sub_category = val;
              } else {
                updated.push({
                  category: "Functional Food & Beverages",
                  sub_category: val,
                });
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            });






          }}
          checked={
            !!data.focus_categories?.some(
              (fc) => fc.category === "Functional Food & Beverages"
            )
          }
          setChecked={() =>
            setData((prev) => {
              const current = [...(prev.focus_categories || [])];
              const exists = current.find(
                (fc) => fc.category === "Functional Food & Beverages"
              );

              let updated: typeof current;

              if (exists) {
                updated = current.filter(
                  (fc) => fc.category !== "Functional Food & Beverages"
                );
              } else {
                updated = [
                  ...current,
                  { category: "Functional Food & Beverages", sub_category: [] },
                ];
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            })
          }
          otherInputValue={otherInputValueFAB}
          setOtherInputValue={setOtherInputValueFAB}

        />
        {/* Pet Nutrition */}
        <MultiSelectWithAddItem
          isFromBrands={true}
          label="Pet Nutrition"
          error={validationErrorForall. petNutrition}
          customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          activeMarket="brands"
          contextKey="petNutrition"
          options={petNutrition}
          showAddCustom
          selected={
            data.focus_categories?.find((fc) => fc.category === "Pet Nutrition")
              ?.sub_category || []
          }
          setSelected={(val) => {
            setData((prev) => {
              const updated = [...(prev.focus_categories || [])];
              const index = updated.findIndex(
                (fc) => fc.category === "Pet Nutrition"
              );

              if (index !== -1) {
                updated[index].sub_category = val;
              } else {
                updated.push({
                  category: "Pet Nutrition",
                  sub_category: val,
                });
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            });
          }}
          checked={
            !!data.focus_categories?.some(
              (fc) => fc.category === "Pet Nutrition"
            )
          }
          setChecked={() =>
            setData((prev) => {
              const current = [...(prev.focus_categories || [])];
              const exists = current.find(
                (fc) => fc.category === "Pet Nutrition"
              );

              let updated: typeof current;

              if (exists) {
                updated = current.filter(
                  (fc) => fc.category !== "Pet Nutrition"
                );
              } else {
                updated = [
                  ...current,
                  { category: "Pet Nutrition", sub_category: [] },
                ];
              }

              return {
                ...prev,
                focus_categories: updated,
              };
            })
          }
          showCheckBox={true}
        />




      </div>
      {/* Desktop Next/Previous Navigation */}
      {!isMobile && (
        <div className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto">
          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
            onClick={handleNext}
            label={"Next"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          }
          <NavigationButton
            onClick={handleNext}
            label={"Next"}
            type="primary"
            block
          />
        </div>
      )}

    </div>
  );
};

export default AreaOfExpertisePage;